import React from 'react'
import { Grid} from '@material-ui/core'
export const Education = () => {
    return (
        
            
                <p>01-02-2019 - actualmente</p>
            
            
        
    )
}
